export default {
  title: 'PROVIDER WORK LIMIT',
  items: {
    ProviderMinRestMins: {
      label: 'Provider Minimum Rest Minutes',
      type: 'integer',
      unit: 'minutes'
    },
    ProviderMaxWorkMins: {
      label: 'Provider Maximum Work Minutes',
      type: 'integer',
      unit: 'minutes'
    },
    // ProviderMaxGapMins: {
    //   label: 'Provider Maximum Gap Minutes',
    //   type: 'integer',
    //   unit: 'minutes'
    // },
  }
}




// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/provider-work-limit.js